import React, { useContext, useEffect, useState } from 'react';
import Select from "react-select";
import { Icon } from '@iconify/react';
import { ToastContainer, toast } from 'react-toastify';
import { AddAdminRole, constituencyMappedList, GetAdminRoleDropdown, roleAssignedList} from '../../Services/allApi';
import DatePicker from 'react-datepicker';

function UpdateRole({detailsTable ,handleCloseModalSS,roleChanged,setRoleChanged}) {
    const [currentStep, setCurrentStep] = useState(1);
    const [completedSteps, setCompletedSteps] = useState([]);
    const [videoDetailsArray, setVideoDetailsArray] = useState([]);
    const [sessionList, setSessionList] = useState([]);
    const [klaList, setKlaList] = useState([]);
    const [memberList, setMemberList] = useState([]);
    const [constituencyList, setconstituencyList] = useState([]);
    const [saluationtList, setSaluationtList] = useState([]);
    const [roleList, setRoleList] = useState([]);
    const [selectedOptionconstituency, setSelectedOptionconstituency] = useState(null);

    const [inputType, setinputType] = useState('text');
    const [VideoInitialDetails, setVideoInitialDetails] = useState({
        startDate: null,
        endDate: null,
        kla: null,
        video_session: null,
    });

    const [SessionIdAfterConnected, setSessionIdAfterConnected] = useState('')

    // sittings logic starts
    const [currentEntry, setCurrentEntry] = useState({
        role: '',
        // adminN: '',
        id: ''
    });

    const [entryList, setEntryList] = useState([]);

    const handleInputChangeSittings = (field, value) => {
        console.log(value);
        setCurrentEntry({
            ...currentEntry,
            [field]: value
        });
    };

    const handleAddEntry = () => {
        if (currentEntry.role) {
            setEntryList([...entryList, currentEntry]);
            setCurrentEntry({
                role: '',
                // adminN: '',
            });
        } else {
            toast.warning("Fill the form completely to add");
        }
    };

    const handleInputChangeListSittings = (index, field, value) => {
        const newEntryList = [...entryList];
        newEntryList[index][field] = value;
        setEntryList(newEntryList);
    };

    const handleRemoveEntry = (index) => {
        const newEntryList = entryList.filter((_, i) => i !== index);
        setEntryList(newEntryList);
    };
    const handleSubmit = async () => {
        const token = sessionStorage.getItem('access_token');
        const reqHeader = {
            "Content-Type": "application/json",
            "Authorization": `${token}`
        };
        console.log(JSON.stringify(entryList, null, 2));

        // const modifiedSittingsList = entryList?.map(item => (
        //     return item.role?.label,
            
        //     // adminN: item?.adminN,
        // )); 
        const newArry=entryList?.map((item)=>{
            return item?.role?.label
        })
        // console.log(newArry);

        const objToApi={
            "user":detailsTable?.id,
            "roles":newArry
        }
        console.log(objToApi);
        // console.log(JSON.stringify(modifiedSittingsList, null, 2));

        // const klaId = detailsTable?.kla_id;

        const res = await AddAdminRole(objToApi, reqHeader);
        if(res.status==200){
        setRoleChanged(roleChanged+1)
        console.log(res);
        handleCloseModalSS();
        toast.success("Admin Role updated successfully")
        }
        else{
            const messageData = res?.response?.data?.message;
            // Check if messageData is an object
            const errorMessage = typeof messageData === 'object' && messageData !== null
                ? messageData[Object.keys(messageData)?.[0]]?.[0] // Get the first message from the object
                : messageData; // If it's a string, use it directly
            // console.log(errorMessage);
            toast.error(errorMessage ?? "There was a problem updating admin role");

        }
    };
    // sittings logic ends

    // useEffect(() => {
    //     // SittingsList();
    //     setEntryList(
    //         [
    //             {
    //               "role": {
    //                 "value": 2,
    //                 "label": "Admin"
    //               },
    //               "id": ""
    //             },
    //             {
    //               "role": {
    //                 "value": 3,
    //                 "label": "Meta Data Approvel"
    //               }
    //             },
    //             {
    //               "role": {
    //                 "value": 5,
    //                 "label": "Video Publishing"
    //               }
    //             }
    //           ]
    //     )
    // }, []);

    useEffect(()=>{
        roleAssignedListInitail()
    },[])

    const roleAssignedListInitail = async () => {
        const userId = detailsTable?.id
        const token = sessionStorage.getItem('access_token');
        const reqHeader = {
            "Content-Type": "application/json",
            "Authorization": `${token}`
        };

        const res = await roleAssignedList(userId,reqHeader);
        console.log(res);
        setEntryList(res?.data);
    }

    // Fetch Constituency List
    const roleListDropdown = async () => {
        const token = sessionStorage.getItem('access_token');
        const reqHeader = {
            "Content-Type": "application/json",
            "Authorization": `${token}`
        };
        try {
            const res = await GetAdminRoleDropdown(reqHeader);
            setconstituencyList(res?.data?.roles || []);
            console.log(res);
        } catch (error) {
            console.error("Error fetching Constituency list for filter:", error);
        }
    };

    useEffect(() => {
        roleListDropdown();
    }, []);

    const roleOptions = constituencyList.map((item) => ({
        value: item.value,
        label: item?.label
    }));
    // const constituencyoptions=[
    //     {value:1,label:'Admin'},
    //     {value:2,label:'Meta Data Entry'},
    //     {value:3,label:'Meta Data Approvel'},
    //     {value:4,label:'Video Uploading'},
    //     {value:5,label:'Video Publishing'},
    //     {value:6,label:'Proceedings Uploading'},
    //     {value:7,label:'Proceedings Approval'},
    //     {value:8,label:'Public Interface'}
    // ]

    const handlechangeconstituency = (option) => setSelectedOptionconstituency(option);

    return (
        <>
            <div className='flex w-full h-full flex-row' style={{ height: '86vh' }}>
                <div className='w-full flex items-center flex-col overflow-y-scroll overflow-x-hidden' style={{ height: '87vh' }}>
                    <div className='flex flex-row justify-center flex-wrap ms-5 me-5 gap-1 w-full '>
                        <div className='flex flex-col w-full gap-5'>
                            <div className='bg-success px-4 py-2 rounded border'>
                                <h3 className='text-blue-700 text-xl font-bold mb-4 text-center'>Constituency Mapping</h3>

                                <div className='flex flex-row justify-center flex-wrap mb-5 gap-5'>

                                    <div className='flex flex-col w-3/12'>
                                        <label>Admin name</label>
                                        <div
                                            className='dateinput w-full h-10 rounded-lg flex justify-start pl-2 items-center '
                                            style={{ border: '1px solid #384D6C' }}
                                        >
                                            {`${detailsTable.first_name} ${detailsTable?.last_name}`}
                                            </div>
                                    </div>

                                    <div className='w-3/12 flex flex-col '>
                                        <label htmlFor="sdate">Role</label>
                                        <Select
                                        // isMulti
                                            placeholder='Role'
                                            options={roleOptions}
                                            value={currentEntry?.role}
                                            onChange={(e) => handleInputChangeSittings('role', e)}
                                            styles={{
                                                control: (baseStyles, state) => ({
                                                    ...baseStyles,
                                                    borderColor: state.isFocused ? '#384D6C' : '#384D6C',
                                                    height: '2rem',
                                                    borderRadius: '0.5rem',
                                                }),
                                            }}
                                        />
                                    </div>

                                    <div className='w-2/12 flex flex-col ms-5'>
                                        <label style={{ visibility: 'hidden' }}>Add</label>
                                        <button className='w-full py-2 rounded-lg bg-green-500 text-white mb-3' onClick={handleAddEntry}>
                                            Add
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='w-full flex flex-col gap-4 mt-4'>
                        {entryList?.map((entry, index) => (
                            <div key={index} className='bg-gray-200 px-4 rounded border'>
                                <h3 className='text-gray-700 text-sm text-left'>No {index + 1}</h3>

                                <div className='flex flex-row justify-center flex-wrap mb-1 gap-5'>

                                    {/* <div className='flex flex-col w-3/12'>
                                        <label>Admin name</label>
                                        <input
                                            type="text"
                                            value={entry.adminN}
                                            onChange={(e) => handleInputChangeListSittings(index, 'adminN', e.target.value)}
                                            className='dateinput w-full h-10 rounded-lg'
                                            style={{ border: '1px solid #384D6C' }}
                                        />
                                    </div> */}

                                    <div className='w-3/12 flex flex-col '>
                                        <label>Role</label>
                                        <Select
                                            options={roleOptions}
                                            value={entry.role}
                                            onChange={option => handleInputChangeListSittings(index, 'role', option)}
                                            styles={{
                                                control: (baseStyles, state) => ({
                                                    ...baseStyles,
                                                    borderColor: state.isFocused ? '#384D6C' : '#384D6C',
                                                    height: '2rem',
                                                    borderRadius: '0.5rem',
                                                }),
                                            }}
                                        />
                                    </div>

                                    <div className='w-2/12 flex flex-col ms-5'>
                                        <label style={{ visibility: 'hidden' }}>Remove</label>
                                        <button className='w-full py-2 rounded-lg bg-red-500 text-white mb-3' onClick={() => handleRemoveEntry(index)}>
                                            Remove
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                   
                        <div className='flex flex-row justify-center gap-5 w-full '>
                            <div className='w-2/12 mb-5'>
                                <button className='w-full py-2 mt-20 text-white rounded-full bg-primary' onClick={handleSubmit}>
                                    Submit
                                </button>
                            </div>

                            <div className='w-2/12'>
                                <button className='w-full py-2 mt-20 rounded-full text-red-500 bg-success border' onClick={handleCloseModalSS}>
                                    Cancel
                                </button>
                            </div>
                        </div>
                    
                </div>
            </div>

            <ToastContainer
                position="top-center"
                autoClose={4000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                draggable
                pauseOnHover
                theme="light"
            />
        </>
    );
}

export default UpdateRole;
